import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Feedback, Text } from '@hausgold/designsystem';
import { useField, ErrorMessage } from 'formik';
import { Slider as Slider$1, SliderTrack, SliderFilledTrack, Tooltip, SliderThumb } from '@chakra-ui/react';
import Default from './Default.js';
import { jsx } from '@emotion/react';
var Slider = function Slider(_ref) {
  var stepKey = _ref.stepKey,
    lineKey = _ref.lineKey,
    unit = _ref.unit,
    placeholder = _ref.placeholder,
    mandatory = _ref.mandatory,
    options = _ref.options,
    min = _ref.min,
    max = _ref.max,
    stepSize = _ref.stepSize,
    defaultValue = _ref.defaultValue;
  var _useField = useField(stepKey),
    _useField2 = _slicedToArray(_useField, 3),
    meta = _useField2[1],
    helper = _useField2[2];
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    rangeValue = _useState2[0],
    setRangeValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showTooltip = _useState4[0],
    setShowTooltip = _useState4[1];
  var handleRangeChange = function handleRangeChange(value) {
    setRangeValue(value);
    helper.setValue(value);
  };
  useEffect(function () {
    // Only update after input is touched.
    // Otherwise, the initial call would prevent the slider from start at the specified defaultValue.
    if (meta.touched) setRangeValue(meta.value);
  }, [meta.value, meta.touched]);
  return jsx(Fragment, null, jsx(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, jsx(Flex, {
    w: {
      base: '90%',
      sm: '80%',
      md: '60%'
    },
    maxW: "500px",
    mb: 8,
    flexWrap: {
      base: 'wrap',
      sm: 'nowrap'
    },
    justifyContent: "space-between"
  }, jsx(Box, {
    mr: 4,
    order: 1
  }, min, "\xA0", unit), jsx(Slider$1, {
    value: rangeValue,
    min: min,
    max: max,
    step: stepSize,
    onChange: handleRangeChange,
    onMouseEnter: function onMouseEnter() {
      return setShowTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowTooltip(false);
    },
    focusThumbOnChange: false,
    size: "lg",
    order: 2
  }, jsx(SliderTrack, null, jsx(Box, {
    position: "relative",
    right: 10
  }), jsx(SliderFilledTrack, null)), jsx(Tooltip, {
    hasArrow: true,
    bg: "blue.400",
    color: "white",
    placement: "top",
    isOpen: showTooltip,
    label: "".concat(rangeValue, " ").concat(unit !== null && unit !== void 0 ? unit : '')
  }, jsx(SliderThumb, {
    boxSize: 6
  }))), jsx(Box, {
    ml: 4,
    order: {
      base: 1,
      sm: 3
    }
  }, max, "\xA0", unit)), jsx("div", null, jsx(Default, _extends({
    type: "text",
    onKeyDown: function onKeyDown(event) {
      if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' &&
      // Allow hotkeys (CTRL+C, CTRL+V)
      !event.ctrlKey && !event.altKey &&
      // Allow mac's hotkeys (CMD+C, CMD+V)
      !event.metaKey &&
      // Allow left and right arrow keys
      event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        event.preventDefault();
      }
    },
    inputMode: "numeric",
    name: stepKey,
    unit: unit
  }, options, {
    stepKey: stepKey,
    lineKey: lineKey,
    placeholder: "".concat(placeholder || '', " ").concat(mandatory ? '*' : '')
  })), jsx(Flex, {
    flexDirection: "column",
    mt: 2,
    justifyContent: "space-between"
  }, jsx(ErrorMessage, {
    name: stepKey
  }, function (message) {
    return jsx(Feedback, {
      mb: 0,
      mx: "auto",
      display: "block"
    }, message);
  }), jsx(Text, {
    as: "div",
    w: "100%",
    textAlign: {
      base: 'inherit',
      md: 'center'
    },
    color: "gray.400",
    mb: 0
  }, "Geben Sie, falls bekannt, den exakten Wert ein."), mandatory && !(meta.touched && meta.error) && jsx(Text, {
    as: "span",
    ml: "auto",
    color: "gray.400",
    mb: 0
  }, "* Pflichtfeld")))));
};
Slider.propTypes = {
  mandatory: PropTypes.bool,
  placeholder: PropTypes.string,
  unit: PropTypes.string,
  stepKey: PropTypes.string.isRequired,
  lineKey: PropTypes.string.isRequired,
  options: PropTypes.object,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  stepSize: PropTypes.number,
  defaultValue: PropTypes.number.isRequired
};
Slider.defaultProps = {
  unit: null,
  placeholder: null,
  mandatory: false,
  options: {},
  stepSize: 1
};
export { Slider as default };